import { api } from "../api";

/**
 * commandfindAllByActivated - Function that finds on database all protocols commands by status  
 * /commands/{status}      
 * method GET 
 * @async-function
 */
const commandfindAllByActivated = async (token: string, managerId: number, status: string, page: number, size: number) => {
    const response = await api.get(
        `/commands/${managerId}/${status}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default commandfindAllByActivated;